import { render } from "./AttachmentImage.vue?vue&type=template&id=240283c4"
import script from "./AttachmentImage.vue?vue&type=script&lang=js"
export * from "./AttachmentImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__